import React, {memo, useEffect, useState} from 'react';
import {BrowserRouter as Router, NavLink, Route} from 'react-router-dom';
import {Col, Row} from 'react-bootstrap';
import '../Styles/Reports/webreport.css';
import '../Styles/Analysen/AnalysenComponent.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileDownload} from '@fortawesome/free-solid-svg-icons';
import {checksessiontime} from '../Utils/Common';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import {convert} from 'html-to-text'
//import {clearHTML, clearNBSP,
import {clusterBy} from '../Utils/helpers';
import FirstPage from '../Components/Report/firstpage';
import ReportDetailComponent from '../Components/Report/ReportDetailComponent';
import NextPage from '../Components/Report/nextpage';
import {getReportLink} from '../API/report';
import {INTRO_TEXT, LOGOIMAGEDATA, WORKFLOW_IMAGE_DATA} from '../AppTextConstants';
import ReportAnnotatorViewComponent from '../Components/Report/ReportAnnotatorViewComponent';
import {getCurrentAnalyse} from "../API/annotatorApi";

function ReportPage(props) {

    checksessiontime();
    const [isIndividualPDFActive, setIsIndividualPDFActive] = useState(false);
    let [hinweisContent, setHinweisContent] = useState(props.location.state.hinweisData);
    let [potenzialContent, setPotenzialContent] = useState(props.location.state.potentialData);
    let [risikoContent, setRisikoContent] = useState(props.location.state.risikoData);
    const [hinweisSelectedAGLs, setHinweisSelectedAGLs] = useState([]);
    const [potenzialSelectedAGLs, setPotenzialSelectedAGLs] = useState([]);
    const [risikoSelectedAGLs, setRisikoSelectedAGLs] = useState([]);
    const [hinweisIndividualContent, setHinweisIndividualContent] = useState([]);
    const [potenzialIndividualContent, setPotenzialIndividualContent] = useState([]);
    const [risikoIndividualContent, setRisikoIndividualContent] = useState([]);
    const [projectName, setProjectName] = useState('');
    const [lvID, setLvID] = useState('');
    const [hinweisFullReportCount, setHinweisFullReportCount] = useState();
    const [potenzialFullReportCount, setPotenzialFullReportCount] = useState();
    const [risikoFullReportCount, setRisikoFullReportCount] = useState();
    //const [lvPageData, setLvPageData] = useState(props.location.state);
    const [lvPageData, setLvPageData] = useState(props.lvInfo);

    const [annotationData, setAnnotationData] = useState();

    const ACTIVE_COLOR = '#10b1f4';
    let myurl = props.match.params;
    let onepager = '/' + myurl.company + '/' + myurl.lvid + '/OnePager';
    let potenzial = '/' + myurl.company + '/' + myurl.lvid + '/Potenzial';
    let hinweis = '/' + myurl.company + '/' + myurl.lvid + '/Hinweis';
    let risiko = '/' + myurl.company + '/' + myurl.lvid + '/Risiko';
    let nextPage = '/' + myurl.company + '/' + myurl.lvid + '/NextPage';
    let lvPage = '/' + myurl.company + '/' + myurl.lvid + '/lvPage';

    useEffect(async () => {
        if (hinweisSelectedAGLs.length === 0 && potenzialSelectedAGLs.length === 0 && risikoSelectedAGLs.length === 0) {
            setIsIndividualPDFActive(false);
        }

        //Categories Summary Count
        let path = window.location.pathname;
        let lvID = path.split('/')[2];

        //let pieChartData = await getStatistics(lvID);
        let pieChartData = await getReportLink(lvID)
        let data = await getCurrentAnalyse(lvID, true)
        //data = data.response
        setAnnotationData(data)
        pieChartData = pieChartData.response;
        pieChartData = pieChartData.stats

        setHinweisFullReportCount(pieChartData.Hinweis);
        setPotenzialFullReportCount(pieChartData.Potenzial);
        setRisikoFullReportCount(pieChartData.Risiko);
        setLvPageData(props.location.state)
    }, []);

    function individualTableContent(
        pdf,
        selectedAGLs,
        category,
        content,
        individual,
        tableHeadValues1,
        tableHeadValues2,
        isReportFragen,
        isIndividualReport
    ) {
        //Group by AGL
        let clusterByAGL;
        if (isReportFragen === false && isIndividualReport === false) {
            clusterByAGL = clusterBy(content, 'anspruchsgrundlage');
        } else {
            clusterByAGL = clusterBy(content, 'anspruchsgrundlage');
        }
        clusterByAGL = [clusterByAGL];

        pdf.autoTable({
            theme: 'grid',
            head: [[category]],
            headStyles: {
                fillColor: [255, 255, 255],
                lineColor: 0,
                lineWidth: 0,
                textColor: [0, 0, 0],
                fontSize: 16,
                halign: 'center'
            },
            bodyStyles: {lineColor: 0, lineWidth: 0.2, textColor: [0, 0, 0]}
        });

        selectedAGLs.map((o) => {
            let tableBodyvalues1 = [];
            let tableBodyValues2 = [];

            pdf.autoTable({
                theme: 'grid',
                head: [[o]],
                headStyles: {
                    fillColor: [255, 255, 255],
                    lineColor: 0,
                    lineWidth: 0,
                    textColor: [0, 0, 0],
                    fontSize: 12
                },
                bodyStyles: {lineColor: 0, lineWidth: 0.2, textColor: [0, 0, 0]}
            });

            let contents;
            let individualContent = individual.filter((obj) => obj.anspruchsgrundlage === o);
            if (individualContent.length > 0) {
                contents = individualContent;
            } else {
                contents = clusterByAGL[0][o];
            }


            // Removes 'unique_id' key value for ease of duplicate check
            let newClusterByAGL = contents.map((data) => {
                delete data['unique_id'];
                return data;
            })

            // Prepares unique entries for Web Report
            let reportDataSet = new Set;
            let uniqueReportTableData = [];
            for (let newClusterByAGLEntry of newClusterByAGL) {
                let concatenatedValue = Object.values(newClusterByAGLEntry).join('');
                if (!reportDataSet.has(concatenatedValue)) {
                    reportDataSet.add(concatenatedValue);
                    uniqueReportTableData.push(newClusterByAGLEntry);
                }
            }

            uniqueReportTableData.forEach((data) => {
                let arrayIn = [];
                if (data.shortText !== '') {
                    arrayIn.push(data.ordnungsziffer);
                    arrayIn.push(data.shortText);
                    arrayIn.push(data.reason);
                } else {
                    arrayIn.push(data.ordnungsziffer);
                    arrayIn.push('Kein Kurztext vorhanden');
                    arrayIn.push(data.reason);
                }
                tableBodyvalues1.push(arrayIn);
                tableBodyValues2 = clusterByAGL[0][o].map((item) => {
                    let formelData = '';
                    let returnData;
                    formelData = item.formel;
                    if (isReportFragen === false) {
                        if (item.formel !== 'none' && item.formel !== '') {
                            returnData = item.recomm + '\n\n\n' + formelData;
                        } else {
                            returnData = item.recomm;
                        }
                    } else {
                        if (item.formel !== 'none') {
                            returnData = formelData;
                        } else {
                            returnData = '-';
                        }
                    }
                    return returnData;
                });

                //console.log(convertToPlain(tableBodyValues2[0]),2121)
                //tableBodyValues2 = clearHTML(tableBodyValues2[0]);
                //tableBodyValues2 = clearNBSP(tableBodyValues2);
                //tableBodyValues2 = convertToPlain(tableBodyValues2[0]);
                tableBodyValues2=convert(tableBodyValues2[0],{"wordwrap":null})
            });

            pdf.autoTable({
                theme: 'grid',
                headStyles: {
                    fillColor: [255, 255, 255],
                    lineColor: 0,
                    lineWidth: 0.2,
                    textColor: [0, 0, 0]
                },
                bodyStyles: {lineColor: 0, lineWidth: 0.2, textColor: [0, 0, 0]},
                head: [tableHeadValues1],
                body: tableBodyvalues1
            });

            pdf.autoTable({
                theme: 'grid',
                headStyles: {
                    fillColor: [255, 255, 255],
                    lineColor: 0,
                    lineWidth: 0.2,
                    textColor: [0, 0, 0]
                },
                bodyStyles: {lineColor: 0, lineWidth: 0.2, textColor: [0, 0, 0]},
                head: [tableHeadValues2],
                body: [[tableBodyValues2]]
            });

            pdf.autoTable({
                theme: 'plain'
            });
        });
    }

    function makePDF() {
        //PDF --> jsPDF(orientation, unit, format, compressPdf)
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        pdf.page = 1;
        let tableHeadValues1 = ['OZ', 'Kurztext', 'Ursache'];
        let tableHeadValues2 = ['Empfehlung'];
        let content = 'default';
        let category = 'default';
        let selectedAGLs = 'default';
        let isReportFragen = false;
        let isIndividualReport = true;

        //Hinweis Tables
        if (hinweisSelectedAGLs.length !== 0) {
            category = 'Hinweis';
            content = hinweisContent;
            selectedAGLs = hinweisSelectedAGLs;
            individualTableContent(
                pdf,
                selectedAGLs,
                category,
                content,
                hinweisIndividualContent,
                tableHeadValues1,
                tableHeadValues2,
                isReportFragen,
                isIndividualReport
            );
        }

        //Potenzial Tables
        if (potenzialSelectedAGLs.length !== 0) {
            if (hinweisSelectedAGLs.length !== 0) {
                pdf.addPage('a4', 'portrait');
            }

            category = 'Potenzial';
            content = potenzialContent;
            selectedAGLs = potenzialSelectedAGLs;
            individualTableContent(
                pdf,
                selectedAGLs,
                category,
                content,
                potenzialIndividualContent,
                tableHeadValues1,
                tableHeadValues2,
                isReportFragen,
                isIndividualReport
            );
        }

        //Risiko Tables
        if (risikoSelectedAGLs.length !== 0) {
            if (potenzialSelectedAGLs.length !== 0 || hinweisSelectedAGLs.length !== 0) {
                pdf.addPage('a4', 'portrait');
            }
            category = 'Risiko';
            content = risikoContent;
            selectedAGLs = risikoSelectedAGLs;
            individualTableContent(
                pdf,
                selectedAGLs,
                category,
                content,
                risikoIndividualContent,
                tableHeadValues1,
                tableHeadValues2,
                isReportFragen,
                isIndividualReport
            );
        }

        let totalPages = pdf.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            if (potenzialSelectedAGLs.length === 0 && risikoSelectedAGLs.length === 0) {
                pdf.text(
                    projectName + ' | Individual Report Hinweis | Seite ' + i + ' von ' + totalPages,
                    105,
                    290,
                    'center'
                );
            } else {
                pdf.text(
                    projectName +
                    ' | Individual Report | ' +
                    'LV ID ' +
                    lvID +
                    ' | Seite ' +
                    i +
                    ' von' +
                    ' ' +
                    totalPages,
                    105,
                    290,
                    'center'
                );
            }
        }

        pdf.save('Export_Individual.pdf');
        // reset all the contents of previous user selections
        //selectedAGLs.length = 0;
        hinweisSelectedAGLs.length = 0;
        potenzialSelectedAGLs.length = 0;
        risikoSelectedAGLs.length = 0;
        risikoIndividualContent.length = 0;
        potenzialIndividualContent.length = 0;
        hinweisIndividualContent.length = 0;
        // set the individual report as disabled.
        setIsIndividualPDFActive(false);
    }

    function addGutZuWissenPoint1(pdf) {
        let firstQuestion =
            '1. Haben sich die Massen in den Positionen geändert oder wurden zusätzliche Positionen nötig? ';
        let firstAnswer =
            'Dies ist ein einfacher Nachtrag, den du kennen solltest. Fehlt z. B. ein Anlagenteil und wird dies im Nachhinein gefordert, ' +
            'kannst du dies in Rechnung stellen. Werden 105 statt 100 Heizkörper gefordert, müssen auch 105 bezahlt werden. Werden ' +
            'nur 95 gebraucht, müssen auch nur 95 bezahlt werden. Beachte jedoch: \n \n' +
            '• Der Einheitspreis bleibt für die Ermittlung des Gesamtpreises bestehen, wenn die Massenänderungen sich auf maximal 10% der ursprünglich ' +
            'vorgesehenen Masse der betroffenen Position beschränkt. \n\n' +
            '• Bei einer Ausweitung der Massen um mehr als 10 % können beide Vertragspartner eine ' +
            'Neuermittlung des Einheitspreises verlangen. Der neu ermittelte Preis gilt dann für die Mehrmassen ' +
            'über 110 % der ursprünglich ' +
            'vorgesehenen. (Werden beispielsweise 115 Heizkörper gefordert, sind die zusätzlichen 5 Heizkörper mit ' +
            'dem neuen Preis zu ' +
            'verrechnen.) \n \n' +
            '• Im Falle der Unterschreitung der vertraglich vorgesehenen Massen um mehr als 10 % ist für die verbleibende ' +
            'Gesamtmasse der betroffenen Position auf Verlangen des Auftragnehmers ein höherer Einheitspreis zu vereinbaren, soweit ' +
            'nicht ein anderweitiger Ausgleich erfolgt.';

        pdf.autoTable({
            theme: 'plain',
            head: [[firstQuestion]],
            body: [[firstAnswer]]
        });
    }

    function addGutZuWissenPoint2(pdf) {
        let secondQuestion = '2. Hat sich die Bauzeit geändert?';
        let secondAnswer =
            'Änderungen von Bauumstände führen zu Nachträgen. Dies gilt insbesondere für die Verschiebung der Bauzeit auf einen ' +
            'späteren Termin, (Annahmeverzug) die Verkürzung der Bauzeit (Beschleunigungsmaßnahmen) und auch für die ' +
            'Verlängerung der Bauzeit.(Bauzeitverlängerung)';

        pdf.autoTable({
            theme: 'plain',
            head: [[secondQuestion]],
            body: [[secondAnswer]]
        });
    }

    function addGutZuWissenPoint5(pdf) {
        let fifthQuestion =
            '5. Sind die Bauleistungen so eindeutig und erschöpfend beschrieben, dass du deine ' +
            'Preise sicher und ohne ' +
            'umfangreiche Vorarbeiten berechnen kannst?';
        let fifthAnswer =
            'Die Verdingungsunterlagen müssen alle notwendigen kostenrelevanten Angaben enthalten, die ' +
            'Einfluss auf ihre Kalkulation ' +
            'haben können. Stellst du während der Kalkulation fest, dass die Verdingungsunterlagen nicht alle ' +
            'kostenrelevanten Angaben ' +
            'enthalten, solltest du nach Â§ 12a Abs. 4 VOB/A zusätzliche sachdienliche Auskünfte erbitten. (Beachte ' +
            'die Frist: I.d.R. 1 Tag ' +
            'vor Submission.) Falls keine Antworten der Vergabestelle kommen, kannst du die Fragen als weitere ' +
            'Nachtragspotenziale in ' +
            'die Verhandlung bringen. ' +
            'Sollten die Beschreibungen nicht der Realität auf der Baustelle entsprechen, hast du die Chance auf ' +
            'einen Nachtrag. ' +
            'Überprüfe deshalb immer,\n\n' +
            'a) Sind die örtlichen Verhältnisse oder die Verkehrsverhältnisse anders als diese beschrieben wurden ' +
            'oder erwartet werden ' +
            'konnten?\n\n' +
            'b) Gibt es rechtliche Vorgaben, die anders sind als diese beschrieben wurden oder erwartet werden konnten.\n\n' +
            'c) Ist der Bauablauf oder die Bauabnahme anders als beschrieben oder erwartet werden durfte.\n\n' +
            'd) Sind Schutzmaßnahmen zu treffen, die nicht beschrieben waren oder erwartet werden durften?\n\n' +
            'e) Gibt es Anforderungen bzw. besonderen Anforderungen, die im Vorfeld nicht oder anders angegeben wurden?\n\n' +
            'f) Sind Angaben zu Baustelleneinrichtung und Gerüsten nicht angegeben oder falsch?\n\n' +
            'g) Sind Angaben zur Dokumentation zu machen, die nicht beschrieben oder erwartet werden durften?\n\n' +
            'h) Sind Baustoffe und oder Bauteile nicht zutreffend beschrieben oder fehlen Angaben?\n\n' +
            'i) Der Auftraggeber liefert die Ausführungsplanung, auf deren Grundlage der Auftragnehmer seine Werkstatt und ' +
            'Montageplanung erstellt. Sind die zur Werkstatt und Montageplanung nötigen Angaben vollständig und richtig?';
        pdf.autoTable({
            theme: 'plain',
            head: [[fifthQuestion]],
            body: [[fifthAnswer]]
        });
    }

    function addGutZuWissenPoint3(pdf) {
        let thirdQuestion = '3. Planungsleistungen';
        let thirdAnswer =
            'Planungsleistungen gehören grundsätzlich nicht zum Leistungsumfang der Auftragnehmer von ' +
            'Bauleistungen. Dabei spielt ' +
            'es keine Rolle, ob mit - Entwurfs-, Ausführungs- und Genehmigungsplanung, die Planung des Gebäudes im ' +
            'Ganzen oder ' +
            'nur die der\n\n' +
            '• RLT-Anlage DIN 18379\n' +
            '• Heizungsanlage DIN 18380\n' +
            '• Entwässerungsanlage DIN 18381\n' +
            '• Gebäudeautomationsanlage DIN 18382, DIN 18386\n\n' +
            'gemeint ist. Dies gilt auch für die Planung von Schlitzen und Durchbrüchen. Soll eine Planungsleistung ' +
            'übertragen werden, ' +
            'kann dies im Rahmen eines Werkvertrages auf der Basis der HOAI erfolgen.';

        pdf.autoTable({
            theme: 'plain',
            head: [[thirdQuestion]],
            body: [[thirdAnswer]]
        });
    }

    function addGutZuWissenPoint4(pdf) {
        let fourthQuestion = '4. Abgrenzung von Nebenleistungen und besonderen Leistungen';
        let fourthAnswer =
            'Achte bei Gerüsten, Beschilderung, Befestigungen, dem Schutz von Bau und Anlageteilen, ' +
            'Teilfertigstellungen und ' +
            'Bemusterungen darauf, was Nebenleistung und was Hauptleistung ist.';

        pdf.autoTable({
            theme: 'plain',
            head: [[fourthQuestion]],
            body: [[fourthAnswer]]
        });
    }

    function addGutZuWissenPoint6(pdf) {
        let sixthQuestion = '6. Unterbrechung/Stillstand, "Go slow" und "Stop & Go"';
        let sixthAnswer =
            'Störungen im Sinne von Änderungen eines geplanten Bauablaufs durch Anordnungen des Auftraggebers sind bei negativen Folgen sogenannte Behinderungen. ' +
            'Es gibt 3 ' +
            'Arten von Behinderungen: Unterbrechung/Stillstand, „Go slow“ und „Stop und Go“. Alle drei Behinderungen aus dem ' +
            'Risikobereich des AG haben eine zusätzliche Vergütung zu Folge. Diese kann nach Schadenersatz oder Entschädigung ' +
            'abgerechnet werden.\n\n' +
            'Empfehlung: Da eine bauablaufbezogene ' +
            'Darstellung (Anspruchsvoraussetzung für Schadenersatz) in der Regel nicht plausibel vorgelegt werden kann, ist ' +
            'der Weg über die Entschädigung nach §642 BGB der erfolgversprechendere Weg. Gemäß KG Urteil vom 16.02.2018 - 21 ' +
            'U 66/16 erhält der Unternehmer auch Entschädigung, wenn er langsamer arbeiten kann als kalkuliert.';

        pdf.autoTable({
            theme: 'plain',
            head: [[sixthQuestion]],
            body: [[sixthAnswer]]
        });
    }

    function addGutZuWissenPoint7(pdf) {
        let seventhQuestion = '7. Erfolgserlebnisse für den AG einbauen';
        let seventhAnswer =
            'Baue in das Nachtragsangebot gezielt Positionen ein, bei denen du nachgeben kannst oder ' +
            'die ganz entfallen, können. ' +
            'Räume dem Auftraggeber damit Erfolgserlebnisse ein, die er während einer Verhandlung braucht. Würde der ' +
            'Auftraggeber ' +
            'alle Positionen eines Nachtragsangebots ohne Änderungen akzeptieren müssen, wäre das nicht günstig für ' +
            'die weitere ' +
            'Zusammenarbeit. Auch der Auftraggeber will einmal gewinnen. Genau das räumst du ihm mit diesem Vorgehen ein.';

        pdf.autoTable({
            theme: 'plain',
            head: [[seventhQuestion]],
            body: [[seventhAnswer]]
        });
    }

    function addGutZuWissenPoint8(pdf) {
        let eighthQuestion = '8. Nachtragserstellung';
        let eighthAnswer =
            'Du bist nicht zur Nachtragserstellung verpflichtet. Biete die Erstellung von Nachträgen ' +
            'gegen Vergütung an. In der Regel ' +
            'kannst du bis zu 30 % der Nachtragshöhe als Erstellungspauschale durchsetzen.';

        pdf.autoTable({
            theme: 'plain',
            head: [[eighthQuestion]],
            body: [[eighthAnswer]]
        });
    }

    function addGutZuWissen(pdf) {
        pdf.addPage('a4', 'portrait');
        pdf.setFontSize(8);

        let introText =
            'Eine Besonderheit beim VOB-Vertrag ist, dass der Auftraggeber während der Bauausführung ' +
            'sowohl den Bauentwurf ändern als auch weitere zusätzliche Leistungen, die zur Erbringung der ' +
            'Vertragsleistung notwendig werden, anordnen darf. Grundsätzlich bist du verpflichtet, diesen ' +
            'Anordnungen nachzukommen. Dir steht jedoch eine angepasste Vergütung zu. Somit kommt es - da ' +
            'Änderungen und zusätzliche Leistungen zum Alltag gehören - immer wieder zu Vergütungsanpassungen ' +
            'während der Bauzeit. Neben diesen Arten der Vergütungsanpassung können aber auch (Teil-)Kündigungen ' +
            'sowie Mehr- oder Mindermengen Grundlage einer Änderung der ursprünglichen Vergütung sein. \n\nEs ist ' +
            'zwingend notwendig, über die gesamte Bauzeit permanent den Vergleich zwischen Bau-Soll und Bau-Ist zu ' +
            'führen. Dabei werden die Ausführungspläne und die Anweisungen des Auftraggebers mit dem Vertrag ' +
            'verglichen. Dadurch erkennst du frühzeitig Abweichungen vom Bauvertrag. Nachträge kannst und solltest ' +
            'du entsprechend früh stellen.\n\nUnsere KI kann Potenziale, Hinweise und Risiken erkennen, die im ' +
            'Leistungsverzeichnis angelegt sind. Wie es nachher auf der Baustelle aussieht, wissen wir nicht. \n\nDie ' +
            'folgenden Fragen helfen dir vor der Submission die richtigen Fragen stellen und nach der Submission entsprechende Nachträge stellen zu können.';
        pdf.autoTable({
            theme: 'plain',
            headStyles: {halign: 'center', fontSize: 14},
            head: [['Gut zu wissen']],
            body: [[introText]]
        });

        addGutZuWissenPoint1(pdf);
        addGutZuWissenPoint2(pdf);
        addGutZuWissenPoint3(pdf);
        addGutZuWissenPoint4(pdf);
        addGutZuWissenPoint5(pdf);
        addGutZuWissenPoint6(pdf);
        addGutZuWissenPoint7(pdf);
        addGutZuWissenPoint8(pdf);
    }

    function addHeaderLogo(pdf) {
        pdf.addImage(LOGOIMAGEDATA, 'PNG', 176, 5, 20, 8, undefined, 'FAST');
    }

    function addCorporatePage(pdf) {
        pdf.addPage('a4', 'portrait');

        pdf.setFontSize(35);
        pdf.setTextColor(0);
        pdf.text('Handwerk | digital | einfach', 30, 150);

        pdf.setFontSize(9);
        pdf.setTextColor(0);
        pdf.text('Handwai GmbH', 180, 250, 'right');
        pdf.text('Klausener Weg 24', 180, 255, 'right');
        pdf.text('54516 Wittlich (Germany)', 180, 260, 'right');
        pdf.text('www.handwai.com', 180, 265, 'right');
    }

    function addIntroPage(pdf) {
        pdf.setFont('helvetica', 'bold');

        let spacer0 = [
            ['', '', ''],
            ['', '', '']
        ];
        pdf.autoTable({
            theme: 'plain',
            body: spacer0,
            bodyStyles: {halign: 'center', fontSize: 12}
        });

        let project = ['Projektname: ' + projectName];
        pdf.autoTable({
            theme: 'plain',
            head: [project],
            headStyles: {halign: 'center', fontSize: 20}
        });

        let spacer1 = [['', '', '']];
        pdf.autoTable({
            theme: 'plain',
            body: spacer1,
            bodyStyles: {halign: 'center', fontSize: 12}
        });

        let summaryHead = ['Ergebnisse auf einen Blick'];
        pdf.autoTable({
            theme: 'plain',
            head: [summaryHead],
            headStyles: {halign: 'center', fontSize: 14}
        });

        let summary = [
            [''],
            [
                'Hinweis: ' +
                hinweisFullReportCount +
                ' | ' +
                'Potenzial: ' +
                potenzialFullReportCount +
                ' | ' +
                'Risiko: ' +
                risikoFullReportCount
            ]
        ];
        pdf.autoTable({
            theme: 'plain',
            body: summary,
            bodyStyles: {halign: 'center', fontSize: 12}
        });

        let spacer2 = [
            ['', '', ''],
            ['', '', '']
        ];
        pdf.autoTable({
            theme: 'plain',
            body: spacer2,
            bodyStyles: {halign: 'center', fontSize: 12}
        });

        let workflowHeader = ['Empfohlene nächste Schritte'];
        pdf.autoTable({
            theme: 'plain',
            head: [workflowHeader],
            headStyles: {halign: 'center', fontSize: 14}
        });

        pdf.addImage(WORKFLOW_IMAGE_DATA, 'JPEG', 30, 155, 881 / 6, 339 / 6, undefined, 'FAST');
        pdf.setFontSize(7);
        pdf.setFont('helvetica', 'normal');
        pdf.setTextColor(120);

        pdf.text(INTRO_TEXT, 15, 230, {maxWidth: 180});
    }

    function addFooter(pdfReport, totalPages, isWhitelabelValue) {
        for (let i = 1; i <= totalPages; i++) {
            if (isWhitelabelValue !== 'YES') {
                addHeaderLogo(pdfReport);
            }
            pdfReport.setPage(i);
            pdfReport.setFontSize(10);
            pdfReport.setTextColor(150);
            pdfReport.text(projectName + ' | Seite ' + i + ' von' + ' ' + totalPages, 105, 290, 'center');
        }
    }

    async function downloadFullReport(isWhitelabelValue, hinweisData, potenzialData, risikoData) {
        //Data
        //let pathnameIdentifier = window.location.pathname;
        //let replaceWord;

        // if (pathnameIdentifier.includes('NextPage')) {
        // 	replaceWord = 'NextPage';
        // } else if (pathnameIdentifier.includes('Potenzial')) {
        // 	replaceWord = 'Potenzial';
        // } else if (pathnameIdentifier.includes('Hinweis')) {
        // 	replaceWord = 'Hinweis';
        // } else if (pathnameIdentifier.includes('Risiko')) {
        // 	replaceWord = 'Risiko';
        // } else {
        // 	replaceWord = 'OnePager';
        // }

        //let hinweisDataLink = pathnameIdentifier.replace(replaceWord, 'Hinweis');
        //let potenzialDataLink = pathnameIdentifier.replace(replaceWord, 'Potenzial');
        //let risikoDataLink = pathnameIdentifier.replace(replaceWord, 'Risiko');
        //let lvID = pathnameIdentifier.split('/')[2];

        let hinweisDataContent = hinweisData;
        let potenzialDataContent = potenzialData;
        let risikoDataContent = risikoData;

        //PDF --> jsPDF(orientation, unit, format, compressPdf)
        const pdfReport = new jsPDF('p', 'mm', 'a4', true);

        pdfReport.setFont('Helvetica');

        addIntroPage(pdfReport);
        pdfReport.addPage('a4', 'portrait');

        pdfReport.page = 1;
        let tableHeadValues1 = ['OZ', 'Kurztext', 'Ursache'];
        let tableHeadValues2 = ['Empfehlung'];

        if (hinweisDataContent.length !== 0) {
            let content = hinweisDataContent;
            let category = 'Hinweis';
            let selectedAGLs;
            let allHinweisAGLs = [];
            hinweisContent = hinweisDataContent;
            hinweisContent.map((item) => allHinweisAGLs.push(item.anspruchsgrundlage));
            selectedAGLs = allHinweisAGLs;
            selectedAGLs = [...new Set(selectedAGLs)];

            individualTableContent(
                pdfReport,
                selectedAGLs,
                category,
                content,
                hinweisIndividualContent,
                tableHeadValues1,
                tableHeadValues2,
                false,
                false
            );
            if (potenzialDataContent.length !== 0) {
                pdfReport.addPage('a4', 'portrait');
            }
        }
        if (potenzialDataContent.length !== 0) {
            let allPotenzialAGLs = [];
            let content = potenzialDataContent;
            let category = 'Potenzial';
            let selectedAGLs;
            potenzialContent = potenzialDataContent;
            potenzialContent.map((item) => allPotenzialAGLs.push(item.anspruchsgrundlage));
            selectedAGLs = allPotenzialAGLs;
            selectedAGLs = [...new Set(selectedAGLs)];

            individualTableContent(
                pdfReport,
                selectedAGLs,
                category,
                content,
                potenzialIndividualContent,
                tableHeadValues1,
                tableHeadValues2,
                false,
                false
            );

            if (risikoDataContent.length !== 0) {
                pdfReport.addPage('a4', 'portrait');
            }
        }

        if (risikoDataContent.length !== 0) {
            let allRisikoAGLs = [];
            let content = risikoDataContent;
            let category = 'Risiko';
            let selectedAGLs;
            risikoContent = risikoDataContent;
            risikoContent.map((item) => allRisikoAGLs.push(item.anspruchsgrundlage));
            selectedAGLs = allRisikoAGLs;
            selectedAGLs = [...new Set(selectedAGLs)];

            individualTableContent(
                pdfReport,
                selectedAGLs,
                category,
                content,
                potenzialIndividualContent,
                tableHeadValues1,
                tableHeadValues2,
                false,
                false
            );
        }

        addGutZuWissen(pdfReport);

        let totalPages = pdfReport.getNumberOfPages();

        addFooter(pdfReport, totalPages, isWhitelabelValue);

        if (isWhitelabelValue !== 'YES') {
            addCorporatePage(pdfReport);
            pdfReport.save('Export_Report.pdf');
        } else {
            pdfReport.save('Whitelabel_Report.pdf');
        }
    }

    async function makeReportFragenPDF(hinweisContent) {
        let isReportFragen = true;
        let isIndividualReport = false;
        //let pathnameIdentifier = window.location.pathname;
        /*let replaceWord;
        if (pathnameIdentifier.includes('NextPage')) {
            replaceWord = 'NextPage';
        } else if (pathnameIdentifier.includes('Potenzial')) {
            replaceWord = 'Potenzial';
        } else {
            replaceWord = 'OnePager';
        }*/
        //pathnameIdentifier = pathnameIdentifier.replace(replaceWord, 'Hinweis');
        //let data = await getRepLinkApi(pathnameIdentifier);
        //hinweisContent = data.data['Hinweis'];

        //PDF --> jsPDF(orientation, unit, format, compressPdf)
        const pdfReportFragen = new jsPDF('p', 'mm', 'a4', true);

        pdfReportFragen.page = 1;
        let tableHeadValues1 = ['OZ', 'Kurztext', 'Ursache'];
        let tableHeadValues2 = ['Frage'];
        let content = hinweisContent;
        let category = 'Hinweis';
        let selectedAGLs;

        if (hinweisSelectedAGLs.length !== 0) {
            selectedAGLs = hinweisSelectedAGLs;
        } else {
            let allAGLs = [];
            //hinweisContent = JSON.parse(hinweisContent);
            hinweisContent.map((item) => allAGLs.push(item.anspruchsgrundlage));
            selectedAGLs = allAGLs;
            selectedAGLs = [...new Set(selectedAGLs)];
        }

        individualTableContent(
            pdfReportFragen,
            selectedAGLs,
            category,
            content,
            hinweisIndividualContent,
            tableHeadValues1,
            tableHeadValues2,
            isReportFragen,
            isIndividualReport
        );

        let totalPages = pdfReportFragen.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            pdfReportFragen.setPage(i);
            pdfReportFragen.setFontSize(10);
            pdfReportFragen.setTextColor(150);
            pdfReportFragen.text(projectName + ' | Seite ' + i + ' von' + ' ' + totalPages, 105, 290, 'center');
        }

        pdfReportFragen.save('Export_Fragen.pdf');
    }

    return (
        <div className="border-white">
            <Row>
                <>
                    <Router>
                        <Col style={{paddingRight: 0}}>
                            <div className="emptyDiv card menuStyle"/>
                            <div className="menuTitleContainer card menuStyle">
                                <div className="menuTitleStyle">Web-Report</div>
                            </div>
                            <menu className="menuAddStyle card menuStyle">
                                <div className="firstpageLinkStyle">
                                    <NavLink
                                        activeClassName="is-active"
                                        activeStyle={{color: ACTIVE_COLOR}}
                                        to={onepager}
                                        exact={true}
                                    >
                                        Übersicht
                                    </NavLink>
                                </div>

                                <div>
                                    <NavLink
                                        activeClassName="is-active"
                                        activeStyle={{color: ACTIVE_COLOR}}
                                        to={lvPage}
                                        exact={true}
                                    >
                                        LV-Ansicht
                                    </NavLink>
                                </div>

                                <div>
                                    <NavLink
                                        activeClassName="is-active"
                                        activeStyle={{color: ACTIVE_COLOR}}
                                        to={hinweis}
                                        exact={true}
                                    >
                                        Hinweis
                                    </NavLink>
                                </div>
                                <div>
                                    <NavLink
                                        activeClassName="is-active"
                                        activeStyle={{color: ACTIVE_COLOR}}
                                        to={potenzial}
                                        exact={true}
                                    >
                                        Potenzial
                                    </NavLink>
                                </div>
                                <div className="risikoLinkStyle">
                                    <NavLink
                                        activeClassName="is-active"
                                        activeStyle={{color: ACTIVE_COLOR}}
                                        to={risiko}
                                    >
                                        Risiko
                                    </NavLink>
                                </div>
                                <div className="nextPageLinkStyle">
                                    <div>
                                        <NavLink
                                            activeClassName="is-active"
                                            activeStyle={{color: ACTIVE_COLOR}}
                                            to={nextPage}
                                        >
                                            Nächste Schritte
                                        </NavLink>
                                    </div>
                                </div>
                                {/*<div>*/}
                                {/*	<br/>*/}
                                {/*	<NavLink*/}
                                {/*		activeClassName="is-active"*/}
                                {/*		activeStyle={{color: ACTIVE_COLOR}}*/}
                                {/*		to={lvPage}*/}
                                {/*	>*/}
                                {/*		<div className="reportbuttons btn btn-responsive handwai-btn-pdfdownload">*/}
                                {/*			<FontAwesomeIcon icon={faFile}/>*/}
                                {/*		</div>*/}
                                {/*		<span>&nbsp;</span> LV-Ansicht (Beta)*/}
                                {/*	</NavLink>*/}
                                {/*</div>*/}

                                <div>
                                    <br/>
                                    <button
                                        className="reportbuttons btn btn-responsive handwai-btn-pdfdownload"
                                        onClick={() => {
                                            downloadFullReport('NO', hinweisContent, potenzialContent, risikoContent);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faFileDownload}/>
                                    </button>
                                    <span>&nbsp;</span> Export Report
                                </div>
                                <br/>
                                <div>
                                    <button
                                        className="reportbuttons btn btn-responsive handwai-btn-pdfdownload"
                                        onClick={() => {
                                            downloadFullReport('YES', hinweisContent, potenzialContent, risikoContent);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faFileDownload}/>
                                    </button>
                                    <span>&nbsp;</span> Whitelabel Report
                                </div>
                                <br/>
                                <div>
                                    <button
                                        className="reportbuttons btn btn-responsive handwai-btn-pdfdownload"
                                        onClick={() => makeReportFragenPDF(hinweisContent)}
                                    >
                                        <FontAwesomeIcon icon={faFileDownload}/>
                                    </button>
                                    <span>&nbsp;</span> Export Fragen
                                </div>
                                <br/>
                                <div>
                                    <button
                                        className="reportbuttons btn btn-responsive handwai-btn-pdfdownload"
                                        disabled={!isIndividualPDFActive}
                                        onClick={() => {
                                            if (
                                                hinweisSelectedAGLs.length === 0 &&
                                                potenzialSelectedAGLs.length === 0 &&
                                                risikoSelectedAGLs.length === 0
                                            ) {
                                                setIsIndividualPDFActive(false);
                                                alert('Bitte wählen Sie die gewünschten AGLs für PDF aus.');
                                            } else {
                                                makePDF();
                                            }
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faFileDownload}/>
                                    </button>
                                    <span>&nbsp;</span> Export Individual
                                </div>
                            </menu>
                        </Col>
                        <div className="commonOuterContainer">
                            {
                                <Route
                                    forceRefresh={true}
                                    exact
                                    path={onepager}
                                    render={() => (
                                        <FirstPage
                                            load={true}
                                            setProjectName={setProjectName}
                                            setLvID={setLvID}
                                            {...props}
                                        />
                                    )}
                                />
                            }
                            {
                                <Route
                                    forceRefresh={true}
                                    exact
                                    path={hinweis}
                                    render={() => (
                                        <ReportDetailComponent
                                            lvInfo={lvPageData}
                                        annotationData={annotationData}

                                            load={true}
                                            type="Hinweis"
                                            setIsIndividualPDFActive={setIsIndividualPDFActive}
                                            setHinweisContent={setHinweisContent}
                                            hinweisContent={hinweisContent}
                                            setHinweisSelectedAGLs={setHinweisSelectedAGLs}
                                            hinweisSelectedAGLs={hinweisSelectedAGLs}
                                            hinweisIndividualContent={hinweisIndividualContent}
                                            setHinweisIndividualContent={setHinweisIndividualContent}
                                            lvID={myurl.lvid}
                                            pageData={lvPageData}
                                            projectName={projectName}
                                        />
                                    )}
                                />
                            }
                            {
                                <Route
                                    forceRefresh={true}
                                    path={potenzial}
                                    render={() => (
                                        <ReportDetailComponent
                                            lvInfo={lvPageData}
                                        annotationData={annotationData}

                                            load={true}
                                            type="Potenzial"
                                            setIsIndividualPDFActive={setIsIndividualPDFActive}
                                            setPotenzialContent={setPotenzialContent}
                                            potenzialContent={potenzialContent}
                                            setPotenzialSelectedAGLs={setPotenzialSelectedAGLs}
                                            potenzialSelectedAGLs={potenzialSelectedAGLs}
                                            potenzialIndividualContent={potenzialIndividualContent}
                                            setPotenzialIndividualContent={setPotenzialIndividualContent}
                                            lvID={myurl.lvid}
                                            pageData={lvPageData}
                                            projectName={projectName}
                                        />
                                    )}
                                />
                            }
                            {
                                <Route
                                    forceRefresh={true}
                                    exact
                                    path={risiko}
                                    render={() => (
                                        <ReportDetailComponent
                                            lvInfo={lvPageData}
                                        annotationData={annotationData}

                                            load={true}
                                            type="Risiko"
                                            setIsIndividualPDFActive={setIsIndividualPDFActive}
                                            setRisikoContent={setRisikoContent}
                                            risikoContent={risikoContent}
                                            setRisikoSelectedAGLs={setRisikoSelectedAGLs}
                                            risikoSelectedAGLs={risikoSelectedAGLs}
                                            risikoIndividualContent={risikoIndividualContent}
                                            setRisikoIndividualContent={setRisikoIndividualContent}
                                            lvID={myurl.lvid}
                                            pageData={lvPageData}
                                            projectName={projectName}
                                        />
                                    )}
                                />
                            }
                            {<Route forceRefresh={true} exact path={nextPage} render={() => <NextPage {...props} />}/>}
                            {
                                <Route exact path={lvPage}>
                                    {' '}
                                    <ReportAnnotatorViewComponent
                                        lvInfo={lvPageData}
                                        annotationData={annotationData}
                                    />{' '}
                                </Route>
                            }
                        </div>
                    </Router>
                </>
            </Row>
        </div>
    );
}

export default memo(ReportPage);
